// Generated types for ValidationTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { LLMTaskReadAPI, LLMTaskWriteAPI } from '../../llm_task/types/llmtask';
import { LLMTaskReadAPISchemaObject, LLMTaskWriteAPISchemaObject } from '../../llm_task/types/llmtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ValidationTaskReadAPI extends LLMTaskReadAPI {
}

export interface ValidationTaskWriteAPI extends LLMTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ValidationTaskReadAPISchema: z.ZodType<ValidationTaskReadAPI> = LLMTaskReadAPISchemaObject.extend({}).passthrough();

export const ValidationTaskWriteAPISchema: z.ZodType<ValidationTaskWriteAPI> = LLMTaskWriteAPISchemaObject.extend({}).passthrough();
